import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { AM_TP_DEMO_ROUTES, TAmDemoTemplateListResponse } from './types';

/**
 * The demo's template library, for S13's picker.
 *
 * Not the product's `document-template/list`: that route is guarded for admins with 2FA or an agent firm, which
 * a presenting account satisfying every `/demo/*` route does not necessarily meet, and its list is not scoped to
 * a company — on a shared database it carries every other tenant's templates too.
 */
export function useAmTpDemoTemplateList() {
  const {
    data,
    error,
    mutate,
  }: {
    data?: TAmDemoTemplateListResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    AM_TP_DEMO_ROUTES.templateList,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading: !data && !error,
  };
}
